/**
 * Admin — 排队进场天数（挂买撮合等待）
 */
import { useEffect } from 'react';
import { Alert, Button, Card, Form, InputNumber, Typography, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../../api/client';
import { useAuthStore } from '../../store/auth';

interface HangQueueSettings {
  buy_match_delay_days: number;
  config_key: string;
}

export function HangQueueConfigPage() {
  const qc = useQueryClient();
  const hasNode = useAuthStore((s) => s.hasNode);
  const canEdit = hasNode('system.config.edit');
  const [form] = Form.useForm();

  const query = useQuery({
    queryKey: ['admin', 'hang-queue'],
    queryFn: () => api.get<HangQueueSettings>('/api/admin/ops-config/hang-queue/settings'),
  });

  useEffect(() => {
    if (query.data) form.setFieldsValue(query.data);
  }, [query.data, form]);

  const save = useMutation({
    mutationFn: (body: { buy_match_delay_days: number }) =>
      api.put<HangQueueSettings>('/api/admin/ops-config/hang-queue/settings', body),
    onSuccess: (data) => {
      message.success('排队进场设置已保存');
      form.setFieldsValue(data);
      qc.setQueryData(['admin', 'hang-queue'], data);
    },
    onError: (e) => message.error(e instanceof ApiError ? e.message : '保存失败'),
  });

  return (
    <>
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        排队进场
      </Typography.Title>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="挂买入队后，满设定天数才可与挂卖撮合进场。设为 0 表示立即撮合。"
      />
      <Card
        loading={query.isLoading}
        extra={
          canEdit ? (
            <Button type="primary" loading={save.isPending} onClick={() => form.submit()}>
              保存
            </Button>
          ) : null
        }
      >
        <Form form={form} layout="vertical" disabled={!canEdit} onFinish={(v) => save.mutate(v)}>
          <Form.Item
            name="buy_match_delay_days"
            label="进场等待天数"
            rules={[{ required: true, message: '请输入天数' }]}
            extra="默认 25 天；修改后对新旧挂买单均按 create_time 生效"
          >
            <InputNumber min={0} max={3650} step={1} style={{ width: 220 }} addonAfter="天" />
          </Form.Item>
        </Form>
      </Card>
    </>
  );
}

export default HangQueueConfigPage;
